exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nbtips {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black; }\n\n.nbtips .nbtiptext {\n  visibility: hidden;\n  max-width: 120px;\n  min-width: 80px;\n  background-color: rgba(0, 0, 0, 0.4);\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  /* Position the tooltip */\n  position: absolute;\n  right: 0;\n  top: 100%;\n  z-index: 1; }\n\n.nbtips .nbtiptext img {\n  width: 100%;\n  min-width: 100px; }\n\n.nbtips:hover .nbtiptext {\n  visibility: visible; }\n", ""]);

// exports
